// extracted by mini-css-extract-plugin
export default {"wrapper":"Z67UY","block":"CUTjr","priceContainer":"UlerN","text":"WvTP4","price":"pinxu"};